export const redirectTo = (url: string): void => {
  window.location.href = url;
};
